import { Button } from '../../components/Button';
import styled from 'styled-components';

export const VoteWithEmailFormContainer = styled.form`
  padding-top: 20px;
  text-align: left;

  .btnContainer {
    text-align: center;
  }

  button {
    width: auto;
    margin: 15px auto 0;
    padding: 10px;
  }
`;
export const PublicVotingContainer = styled.div`
  width: 100%;
  max-width: 1070px;
  margin: 0 auto;
  padding: 50px 20px;

  @media (max-width: 767px) {
    padding: 20px;
  }
`;

export const PublicVotingLink = styled.div`
  text-align: center;
  margin-bottom: 30px;

  button {
    width: 100%;
    height: auto;
    border: 1px solid #4a9aff;
    background-color: #4a9aff;
    color: #fff;
    cursor: pointer;
    font-weight: bold;
    &:hover {
      background-color: #fff;
      color: #4a9aff;
    }
  }
`;
export const FilterContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  & > div {
    width: calc(100% / 4 - 20px);
  }

  input {
    padding: 7px 10px;
    width: 100%;
  }

  label {
    margin-top: 3px;
  }

  button {
    border: none;
    background: none;
    cursor: pointer;
  }

  .labelSpan {
    font-size: 14px;
  }
  .Dropdown-root {
    margin-top: 5px;
    width: 100%;
  }

  @media (max-width: 767px) {
    flex-direction: column;

    & > div {
      width: 100%;
    }

    .Dropdown-root {
      margin-bottom: 20px;
    }
  }
`;

export const NominationsList = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin: 50px -10px 0;
`;

export const NominationItem = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 300px;
  min-width: 300px;
  margin: 0 10px 20px;
  border: 1px solid #aeaeae;
  border-radius: 4px;
  padding: 20px;
  text-align: center;
  background-color: #fff;

  @media (min-width: 992px) {
    width: 255px;
    min-width: 255px;
  }

  @media (min-width: 1100px) {
    width: calc((100% / 3) - 20px);
    min-width: calc((100% / 3) - 20px);
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

export const NominationLogo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100px;
  margin: 0 auto 20px;
  text-align: center;

  img {
    object-fit: cover;
    max-width: 100%;
    max-height: 100%;
  }
`;

export const NominationInfo = styled.div`
  margin-bottom: 15px;
  font-size: 14px;
  word-break: break-all;

  &:last-child(2) {
    margin-bottom: 20px;
  }

  span {
    font-weight: bold;
  }
`;

export const VoteBtn = styled(Button)`
  width: 150px;
  margin-top: auto;
  background-color: #4a9aff;
  color: #fff;
  border: 1px solid #4a9aff;
  cursor: pointer;
  font-weight: bold;
  padding: 10px;
  font-size: 14px;

  &:hover {
    background-color: #fff;
    color: #4a9aff;
  }
`;

export const VotingModalContainer = styled.div`
  text-align: center;
`;

export const VoteBtnsContainer = styled.div`
  display: flex;
  align-items: flex-start;
  margin-top: 25px;

  .kep-login-facebook {
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #4a9aff;
    border: 1px solid #4a9aff;
    color: #fff;
    cursor: pointer;
    margin-right: 20px;
    padding: 10px 8px;
    font-size: 12px;
    font-weight: bold;
    text-align: left;
    white-space: nowrap;
    outline: none;

    &:hover {
      background-color: #fff;
      color: #4a9aff;
    }

    svg {
      margin-right: 5px;
    }
  }

  @media (max-width: 767px) {
    flex-direction: column;

    & > span {
      display: block;
      width: 100%;
    }

    button {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      margin: 10px 0 0;
    }
  }
`;

export const FbLoginBtnContainer = styled(VoteBtnsContainer)`
  justify-content: center;
  margin-top: 25px;

  button.kep-login-facebook {
    margin-right: 0;
  }
`;

export const FbLoginDescription = styled.p`
  margin-top: 25px;
`;

export const EmailVote = styled(Button)`
  display: flex;
  min-width: auto;
  align-items: center;
  justify-content: space-between;
  background-color: #910d01;
  border: 1px solid #910d01;
  color: #fff;
  cursor: pointer;
  padding: 10px;
  font-size: 12px;
  font-weight: bold;

  &:hover {
    background-color: #fff;
    color: #910d01;
  }

  svg {
    margin-right: 5px;
  }
`;

export const VoteWithEmailContainer = styled.div`
  padding-top: 20px;
  text-align: left;

  button {
    width: auto;
    margin: 15px auto 0;
    padding: 10px;
  }
`;

export const ErrorsList = styled.div`
  margin-top: 10px;
  text-align: center;
`;
export const ModalBody = styled.div`
  h4 {
    font-weight: bold;
    text-align: center;
    margin-bottom: 10px;
  }

  ul {
    text-align: center;
    margin-bottom: 20px;

    li {
      font-size: 14px;
      margin-bottom: 5px;
    }
  }
`;

export const SocialContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  .SocialMediaShareButton {
    cursor: pointer;

    & + .SocialMediaShareButton {
      margin-left: 20px;
    }
  }
`;

export const ShareLink = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  width: 30px;
  height: 30px;
  border: 1px solid #aeaeae;
  border-radius: 50%;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    background: none;
    border: none;
    border-radius: 50%;
    padding: 0;
    width: 100%;
    height: 100%;
    outline: none;
    transition: all 0.2s;

    &:hover {
      background: azure;
    }
  }
`;

export const FooterText = styled.div`
  margin: 0 0 15px;
  font-size: 16px;
  text-align: center;
`;
